// TSS vite/06 — dp versioning scheme. Newest entry first.
// Type enum: 'feature' | 'fix' | 'improvement' | 'breaking'.

const CHANGELOG = [
    {
        version: 'dp1.9',
        date: '2026-07-03',
        title: 'Detalle de receptora con KPIs reales',
        notes: [
            { type: 'fix',         text: 'Al abrir una receptora desde Parcerías ahora se ven SUS datos reales: producción, embudo, tasas, estado reproductivo con fechas estimadas e historial de transferencias (antes mostraba datos de ejemplo o nada)' },
            { type: 'improvement', text: 'Retirados el aviso "datos de ejemplo" y la sección "Eventos médicos" (operación interna, fuera del canal del portal); el portal ya no usa ningún dato simulado' },
        ],
    },
    {
        version: 'dp1.8',
        date: '2026-07-03',
        title: 'Reparto de la liquidación mensual del socio en Mis vacas',
        notes: [
            { type: 'feature',     text: 'Cada vaca de la grilla muestra "Tu reparto del mes": el dinero real que te correspondió en la última liquidación, con su período' },
            { type: 'feature',     text: 'Sección "Liquidación mensual" en el detalle de la donadora: última liquidación (período, días, tarifa/día, pensión, tu % del reparto y tu reparto) + histórico por mes' },
            { type: 'improvement', text: 'Conceptos separados con claridad: tu participación (%), tu reparto del mes (dinero real) y el valor de tu participación (pendiente de valoración del staff)' },
            { type: 'improvement', text: '"Liquidación mensual" y "Tu reparto" salen de Próximamente — ya son datos reales; quedan Estado de cuenta y ROI neto' },
        ],
    },
    {
        version: 'dp1.7',
        date: '2026-07-03',
        title: 'Producción SG en el detalle de donadora',
        notes: [
            { type: 'feature',     text: 'Card "Producción (Software Ganadero)" en el detalle de la donadora: último registro de leche (litros/AM/PM), pesaje (peso/alzada) y servicio (toro/tipo) con su fecha' },
            { type: 'improvement', text: 'La card aparece solo cuando hay datos ganaderos conciliados para la donadora; una medición sin registros dice "sin registros aún"' },
        ],
    },
    {
        version: 'dp1.6',
        date: '2026-07-03',
        title: 'Informe reproductivo por finca en el portal',
        notes: [
            { type: 'feature',     text: 'Sección "Informe por finca" en KPIs y estadísticas: por cada finca, tus receptoras con sus transferencias — cruce (donadora × toro), embrión, diagnósticos, parto probable y estado (preñada/vacía/transferida)' },
            { type: 'feature',     text: 'Resumen por finca y total del período con tasa de preñez diagnosticada; comparte el filtro de fechas de los KPIs' },
            { type: 'improvement', text: 'Visible solo para clientes de parcerías (módulo report del backend)' },
            { type: 'improvement', text: 'En el teléfono el informe se ve como tarjetas por receptora (sin desplazamiento horizontal); en ordenador, como tabla' },
        ],
    },
    {
        version: 'dp1.5',
        date: '2026-07-03',
        title: 'Mis indicadores — KPIs reproductivos del cliente',
        notes: [
            { type: 'feature',     text: 'Vista "KPIs y estadísticas" reescrita contra el endpoint real (public/stats?view=kpi): bloques de cowhousing (donadoras) y parcerías (receptoras) con producción, embudo y tasas con semáforo, filtro por rango de fechas' },
            { type: 'feature',     text: 'Cada bloque aparece según tus datos (available_modules); sin actividad en el período muestra "sin datos aún"' },
            { type: 'improvement', text: 'Indicadores unificados con la identidad visual del dashboard (tarjetas con icono, embudo con rampa de color, semáforo por calificador del backend) y compartidos entre informes, detalle de receptora y detalle de donadora' },
            { type: 'improvement', text: 'Pestaña de KPIs visible también para clientes cowhousing (antes solo parcerías); retirado el informe provisional con datos de ejemplo' },
        ],
    },
    {
        version: 'dp1.4',
        date: '2026-07-03',
        title: 'Proponer donadoras — registro con verificación',
        notes: [
            { type: 'feature',     text: 'Vista "Mis propuestas": propone tus donadoras (public/donor-submissions) con finca de origen, raza, datos del animal y valor de compra; el equipo las revisa antes de registrarlas' },
            { type: 'feature',     text: 'Ciclo de curaduría visible: en revisión (editable/retirable), verificada (enlace a Mis vacas) o rechazada (con el motivo); filtro por estado' },
            { type: 'improvement', text: 'Selector de raza (catálogo público public/races) y badge de estado compartidos en common/' },
        ],
    },
    {
        version: 'dp1.3',
        date: '2026-07-03',
        title: 'Mis receptoras — crear, editar y borrar',
        notes: [
            { type: 'feature',     text: 'Escritura de receptoras en parcerías (public/recipients): alta con número + finca, edición (incluye reubicar de finca) y baja con confirmación' },
            { type: 'feature',     text: 'Selector de finca (FarmSelect) alimentado por tus fincas; sin fincas muestra el CTA "Crea una finca primero" y bloquea el envío' },
            { type: 'improvement', text: 'Errores del contrato bajo el campo correcto: número duplicado en la finca (409) y finca inválida (422)' },
            { type: 'breaking',    text: 'Modo preview (VITE_PREVIEW) eliminado: el portal habla únicamente con rutas reales del backend' },
        ],
    },
    {
        version: 'dp1.2',
        date: '2026-07-02',
        title: 'Mis fincas — gestión de fincas del cliente',
        notes: [
            { type: 'feature',     text: 'Vista "Mis fincas": crea, edita y elimina tus fincas (public/farms) con grilla de tarjetas, paginación offset y empty-state con CTA' },
            { type: 'feature',     text: 'Borrado con guarda referencial: si la finca tiene receptoras o propuestas de donadora activas, el diálogo muestra los conteos que lo bloquean (409)' },
            { type: 'improvement', text: 'Primitivos compartidos: campo de formulario (Field), diálogo de confirmación (ConfirmDialog) y lectura de fincas (useClientFarms) promovidos a common/ para receptoras y donadoras' },
        ],
    },
    {
        version: 'dp1.1',
        date: '2026-07-02',
        title: 'Dashboard cowhousing — Mis vacas',
        notes: [
            { type: 'feature',     text: 'Grilla "Mis vacas": donadoras co-poseídas (GET public/donors) con valor de la vaca, tu participación y retorno por crías (COP), paginación offset' },
            { type: 'feature',     text: 'Dashboard de donadora (GET public/donors/:id): producción, embudo, tasas con semáforo del backend, crías y económico propio; 404 amable si no es tuya' },
            { type: 'feature',     text: 'Bloque agregado del lote (GET public/stats?view=kpi → donors_kpi), visible solo si el módulo viene en available_modules' },
            { type: 'improvement', text: 'KPIs económicos pendientes (liquidación, reparto, estado de cuenta, ROI) señalizados como "Próximamente" sin cablear datos' },
        ],
    },
    {
        version: 'dp1.0',
        date: '2026-07-01',
        title: 'Portal de clientes — Fase 1',
        notes: [
            { type: 'feature',     text: 'Login de cliente contra el canal público (POST public/auth/login, identifier + password, sin enumeración)' },
            { type: 'feature',     text: 'Vista "Mis parcerías": lista de receptoras del cliente (GET public/recipients) con paginación offset, estados de carga/vacío/error' },
            { type: 'feature',     text: 'Header con pestañas por roles_with_data (solo roles con datos y ruta; Fase 1 = parcerías)' },
            { type: 'improvement', text: 'AuthProvider adaptado al canal público (public/me, public/permissions) con grants y matching de wildcards' },
            { type: 'improvement', text: 'Sync automático del contrato api-reference (scripts/sync_contract.sh) en postinstall/predev/prebuild' },
        ],
    },
];

export default CHANGELOG;
